/**
 * Tokeny PDF-a raportu — odpowiedniki zmiennych z `variables.scss`. react-pdf nie widzi CSS-a, więc
 * kolory muszą tu być literalne; trzymamy je w jednym miejscu, żeby dało się je porównać ze stroną.
 */
export const PDF_COLORS = {
  primary: '#1b5ff8',
  primary100: '#eff4ff',
  primary200: '#b3c9fc',
  primary300: '#6794fa',
  primary400: '#4c7dea',
  primary600: '#164fce',
  primary700: '#0d2f7c',
  /** `--primary-500` ze strony — kolor tekstu w żetonach marek. */
  primaryText: '#182546',
  secondary: '#53cba2',
  /** `--secondary-ux-600` — kolor ikony `ico--chart-up` w panelu (ciemniejszy od `secondary`). */
  secondary600: '#45a987',
  secondary100: '#e2f6ef',
  secondary300: '#8cdcc1',
  secondary700: '#296551',
  grey900: '#1a1a1a',
  grey800: '#303030',
  grey700: '#545454',
  grey600: '#686869',
  grey500: '#959596',
  grey300: '#c7c4c4',
  grey200: '#e3e1e1',
  grey100: '#f5f3f3',
  grey60: '#f2f2f6',
  grey50: '#f7f7f8',
  grey10: '#f9f9fa',
  stroke: '#e0e0ea',
  white: '#ffffff',
} as const;

/** Wysokość poświaty pod okładką w punktach — odpowiednik 520px gradientu na stronie. */
export const PDF_GRADIENT_HEIGHT = 260;

export const PDF_PAGE = {
  width: 595.28,
  height: 841.89,
  margin: 36,
} as const;

export const PDF_CONTENT_WIDTH = PDF_PAGE.width - PDF_PAGE.margin * 2;

/**
 * Szerokość treści na stronie POZIOMEJ (`orientation="landscape"`) — wymiary A4 zamieniają się
 * miejscami. Tak stoi karta z tabelami tematów: pionowa strona nie mieści ich kolumn.
 */
export const PDF_CONTENT_WIDTH_LANDSCAPE = PDF_PAGE.height - PDF_PAGE.margin * 2;
